import React from 'react';
import CanvasFrameContent from './CanvasFrameContent';
import type { CanvasFrame } from '../types';

interface Props {
  frame: CanvasFrame;
}

/**
 * Poort van het prototype's buildAreaElement (content + vorm), bewust ZONDER
 * klik/dubbelklik-handlers -- navigatie-besluit #3: geen klik-navigatie in
 * Stap 1, alleen betrouwbare pad-navigatie vanaf de telefoon.
 */
export default function CanvasFrameElement({ frame }: Props) {
  return (
    <div
      className={`canvas-frame canvas-frame--${frame.shape} canvas-frame--level-${frame.level}`}
      style={{
        left: frame.x,
        top: frame.y,
        width: frame.width,
        height: frame.height,
        transform: frame.rotation ? `rotate(${frame.rotation}deg)` : undefined,
      }}
    >
      <CanvasFrameContent frame={frame} />
    </div>
  );
}
